module.exports = __webpack_public_path__ + "img/practikum-polskie-radio.dd104914.png";